export interface KanbanDragEndItemEvent<T, S> {
  item: T;
  fromStage?: S;
  toStage?: S;
}
